import styled from 'styled-components';
import { BreakpointSizes } from 'dbi-pearl-ui-kit';

export default styled.div`
    display: grid;
    height: 100vh;
    grid-template-columns: 1fr;
    width: 100%;
    position: relative;
    overflow-y: hidden;
    ${(props) => props.theme.pearlBreaks.up(BreakpointSizes.MD)} {
        height: 95vh;
    }
    ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.SM)} {
        height: 1120px;
    }
    .rightSide {
        height: 100vh;
    }

    .innerRight {
        flex: 2 1;
        display: flex;
        flex-direction: column;
        height: calc(100vh - 78px);
        position: relative;
        overflow-y: auto;
        background-color: ${(props) => props.theme.colors.background.container};
    }

    footer {
        height: 78px;
        width: 100%;
    }

    .title {
        text-transform: none;
        margin-top: 10px;
        margin-bottom: 0px;
        font-weight: 700;
        font-size: 40px;
        line-height: 48px;

        @media (max-width: 815px) {
            font-size: 32px;
        }
    }

    .stepHeader,
    .stepComponent {
        padding-left: 48px;
        padding-right: 48px;
        width: auto;

        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.LG)} {
            padding-left: 48px;
            padding-right: 48px;
        }

        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 20px;
        }
        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.SM)} {
            padding: 0px 16px;
        }
    }

    .stepHeader {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;

        & > :first-child.actions {
            ${(props) => props.theme.pearlBreaks.up(BreakpointSizes.MD)} {
                padding-top: 96px;
            }
        }

        & > :first-child:not(.actions) {
            padding-top: 100px;
        }

        .eventUserTitles {
            margin: 20px 0 0;
        }
    }

    .stepComponent {
        min-height: 100px;
        flex: 1 1 100%;
        display: flex;
        flex-direction: column;
        justify-content: start;
        padding-top: 0;
        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
            padding-bottom: 20px;
            min-height: auto;
        }

        .formWrapper {
            padding-bottom: 40px;
            margin-bottom: 100px;

            ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
                padding-bottom: 0;
                margin-bottom: 0;
            }
        }
    }

    .formComponent {
        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
            margin: 0px 0px 0px 0px;
        }
    }

    .image {
        display: flex;
        position: relative;
        width: 100%;
        height: 100vh;
        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }

        .logo {
            height: auto;
            width: 25%;
        }
    }

    .subtitle {
        color: ${(props) => props.theme.colors.foreground.secondary_text};
        margin-bottom: 0px;
        margin-top: 10px;
    }

    ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
        display: grid;
        grid-template-rows: 32% auto;
        grid-template-columns: unset;
        height: 100%;
        overflow-y: auto;
        width: 100vw;

        footer {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
        }

        .image {
            height: 100%;
            flex: 1 0 auto;
            width: 100vw;
            max-width: unset;
        }

        .rightSide {
            height: 100%;
            width: 100vw;
        }

        .innerRight {
            height: calc(100% - 79px);
            overflow: visible;
        }

        .stepHeader {
            padding-top: 96px;
        }
    }
    ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.SM)} {
        .stepHeader {
            padding-top: 12px;
            padding-left: 16px;
            padding-right: 16px;
        }
    }
`;
